const { default: axiosInstance } = require("utils/axios");

const getOptionCarBrands = async () => {
  try {
    const response = await axiosInstance.get("/car-buy/get-brand-car");
    return response.data;
  } catch (error) {
    console.error("Error fetching car brands:", error);
    throw error;
  }
};

const getCarStatusOptions = async () => {
  try {
    const response = await axiosInstance.get("/car-buy/get-status-car");
    console.log("Car Status Response:", response);
    return response.data;
  } catch (error) {
    console.error("Error fetching car status options:", error);
    throw error;
  }
};

const CarService = {
  getOptionCarBrands,
  getCarStatusOptions,
};
export default CarService;
